<div
  *ngIf="textContent$ | async"
  class="text-with-side-image flex pr-large-t"
  [ngClass]="{
    'black-friday': isBlackFriday$ | async,
    'mr-large-b': noPadding$ | async,
    'mr-large-y': (noPadding$ | async) === false,
    'no-padding': noPadding$ | async,
    'pr-xlarge-t': (noPadding$ | async) === false,
    'pr-large-t': noPadding$ | async,
    'section-marker': showSectionMarker$ | async,
  }"
>
  <div class="text-with-side-image-article pr-xsmall-r">
    <cms-rich-text [content$]="textContent$" />
    <cms-link-block *ngIf="link$ | async" class="block pr-large-t" [content$]="link$" />
  </div>
  <div
    class="text-with-side-image-image pr-xsmall-l flex overflow-hidden"
    [ngClass]="{
      'disable-cropping flex--align-start': (image$ | async)?.disableCropping,
      'flex--center': (noPadding$ | async) === false,
      'flex--start': noPadding$ | async,
      'pr-xxsmall-t': noPadding$ | async,
    }"
  >
    <fin-content-image *ngIf="image$ | async" [imageData$]="image$" [aspectRatio$]="aspectRatio$" />
  </div>
</div>
